import { useMemo } from "react"

export default <D extends { id: string }>(data: D[]): Record<string, D> =>
    useMemo(
        () =>
            data.reduce(
                (acc, curr) => ({
                    ...acc,
                    [curr.id]: curr,
                }),
                {}
            ),
        [data]
    )
